import { components } from "react-select";
import './Customer.css'
import { variableName } from "../../variableName";

function CustomerFooter() {

    return (
        <>
            <div className="mb-0  w-100 text-center"
                style={{
                    backgroundColor: "#66cccc",
                    padding: "5px",
                    position: "fixed",
                    bottom: 0,
                    zIndex: 999
                }}>
                <p className="m-0" style={{ fontSize: 12 }}>By Reliable Software, Goa. <span className="white">Ph: {variableName.relyPhone}</span> </p>
            </div>
        </>
    )
}

export default CustomerFooter;